export default "__VITE_ASSET__Byz9NOIy__"